<template>
  <div class="select-input">
    <el-select
      v-model="selectLabel"
      placeholder="请选择"
      class="select-input-area"
      @change="onSelectChange"
    >
      <el-option
        v-for="item in _list"
        :key="item.value"
        :label="'+'+item.value"
        :value="item.value"
      >
        <slot>
          <span style="float: left">{{ item.label }}</span>
        </slot>
      </el-option>
    </el-select>
    <el-input
      class="select-input-wrapper"
      v-model="inputValue"
      :placeholder="placeholder"
      @focus="onFocus"
      @input="onInputChange"
    >
    </el-input>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    list: {
      type: Array,
      default: () => []
    },
    defaultValue: {
      type: [String,Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入手机号'
    },
    isArea: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inputValue: '',
      selectLabel: '',
      areas: [
        {
          value: "86",
          label: "大陆",
        },
        {
          value: "852",
          label: "香港",
        },
        {
          value: "853",
          label: "澳门",
        },
        {
          value: "886",
          label: "台湾",
        },
      ],
    };
  },
  computed: {
    _list() {
      if (this.isArea) {
        this.selectLabel = '+86'
        return this.areas
      } else {
        this.selectLabel = this.defaultValue
        this.list
      }
    }
  },
  methods: {
    onFocus(e) {
      this.$emit('onFocus', e)
    },
    onInputChange(e) {
      const value = this.type == 'number' ? e.replace(/[^0-9]/g, '') : e
      this.inputValue = value
      this.$emit('onInputChange', value)
      this.$emit('update:value', value)
    },
    onSelectChange(e) {
      this.$emit('onSelectChange', e)
    }
  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
.select-input {
  position: relative;
  width: 100%;
  background-color: #f3f5f9;
  border-radius: 4px;
}
.select-input-area {
  position: absolute;
  top: 0;
  left: 12px;
  width: 50px;
  z-index: 2;
  >>> .el-input__inner {
    background: transparent;
    border: none;
    padding: 0;
    box-shadow: none;
    height: 42px;
    outline: none;
  }
  >>> .el-input__suffix {
    right: 0;
  }
}
.select-input-wrapper {
  >>> .el-input__inner {
    background: transparent;
    border: none;
    padding: 1px 10px;
    padding-left: 70px;
    box-shadow: none;
    height: 42px;
    outline: none;
    :focus{
      outline: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/Login/components/SelectInput.vue